// eslint-disable-next-line
export function getText(state) {
    let result
    try {
        result = state.locales[state.locale]
    } catch (error) {
        console.info(`Encountered error while setting localized setting: ${error.message}`)
    }

    if (result == null) {
        // return empty result
        return {}
    }

    return result
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/localized/selectors.js